import { Component, OnInit,Input ,Output,EventEmitter} from '@angular/core';
import { ClienteService } from '../../services/cliente.service';

@Component({
  selector: 'app-gestiones-header-preca',
  templateUrl: './gestiones-header-preca.component.html',
  styleUrls: ['./gestiones-header-preca.component.scss']
})
export class GestionesHeaderPrecaComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Input() gestionSeleccionada: any
  @Input() buttonselected: number
  @Input() participante: any
  @Input() clienteserviceParam: ClienteService
  constructor(public clienteservice: ClienteService,) { }

  ngOnInit(): void {
  }
  selectedtab(tab) {
    if (tab == 7) {
      if(!this.clienteserviceParam.rolABFlag){
        this.selectParticipante.emit(0)
        this.selecttab.emit(tab)
      }
    }
    else if (tab == 8) {
      this.selectParticipante.emit(1)
      this.selecttab.emit(7)
    } else if (tab == 5) {//detalle presolicitud
      if (this.gestionSeleccionada.tipoProducto == '004') {
        this.selecttab.emit(19)        
      } else {
        this.selecttab.emit(5)
      }
    }
    else {
      this.selecttab.emit(tab) 
    }
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item)
  }
  flujo() {
    this.selecttab.emit(15)
  }
}
